import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '../Input';
import get from 'lodash/get';
import { isFunction } from '@utiljs/is';
import { connect } from './connect';
import { isValue, getValueFromObjOrArray } from './utils';
import ErrorMessage from './ErrorMessage';
var checkedTypes = ['checkbox', 'radio', 'switch', 'rcheckbox', 'rradio', 'rswitch'];

var Field = /*#__PURE__*/function (_React$Component) {
  _inherits(Field, _React$Component);

  var _super = _createSuper(Field);

  function Field() {
    var _this;

    _classCallCheck(this, Field);

    _this = _super.apply(this, arguments);

    _this.mount = function () {
      var form = _this.props.form;

      if (form && form.mountField && 'rule' in _this.props) {
        form.mountField(_this.props.name, _assertThisInitialized(_this));
      }
    };

    _this.renderContent = function (field, funcField) {
      var _this$props = _this.props,
          children = _this$props.children,
          as = _this$props.as;
      var value = field.value,
          onChange = field.onChange,
          disabled = field.disabled; // 基础类型也应该直接返回

      if (children !== undefined) {
        if (isFunction(children)) {
          return children(funcField);
        } else {
          return children;
        }
      } else if ( /*#__PURE__*/React.isValidElement(as)) {
        var componentProps = {
          onChange: onChange,
          disabled: disabled
        };
        var type = typeof as.type === 'string' ? as.type : as.type.rooName || as.type.displayName || as.type.name;

        if (type && checkedTypes.indexOf(type.toLowerCase()) > -1) {
          componentProps.checked = value;
        } else {
          componentProps.value = value;
        }

        return /*#__PURE__*/React.cloneElement(as, componentProps);
      } else {
        return /*#__PURE__*/React.createElement(Input, _Object$assign({}, field));
      }
    };

    return _this;
  }

  _createClass(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mount();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // TODO: optimize performance
      this.mount();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var form = this.props.form;

      if (form && form.unMountField) {
        form.unMountField(this.props.name);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _a = this.props,
          form = _a.form,
          value = _a.value,
          label = _a.label,
          name = _a.name,
          cols = _a.cols,
          rule = _a.rule,
          status = _a.status,
          required = _a.required,
          hasFeedback = _a.hasFeedback,
          withLabel = _a.withLabel,
          propsDisabled = _a.disabled,
          propsLayout = _a.layout,
          restProps = __rest(_a, ["form", "value", "label", "name", "cols", "rule", "status", "required", "hasFeedback", "withLabel", "disabled", "layout"]);

      var values = form.values,
          errors = form.errors,
          touched = form.touched;
      var formLayout = form.layout,
          disabled = form.disabled;
      var layout = propsLayout || formLayout || 'horizontal';

      if (_typeof(values) !== 'object') {
        values = {};
      }
      /* istanbul ignore next */


      if (_typeof(errors) !== 'object') {
        errors = {};
      } // TODO: without name: do nothing
      // fix status


      var propsValue = name ? getValueFromObjOrArray(values, name) : ''; // eslint-disable-next-line

      var relValue = isValue(value) ? value : isValue(propsValue) ? propsValue : '';
      var error = get(errors, name || '', '');
      var fieldTouched = get(touched, name || '', '');

      var field = _Object$assign(_Object$assign({}, restProps), {
        name: name,
        value: relValue,
        disabled: propsDisabled || disabled,
        onChange: form.handleChange && form.handleChange.bind(this, name),
        onBlur: form.handleBlur && form.handleBlur.bind(this, name)
      });

      var funcField = _Object$assign(_Object$assign({}, restProps), {
        name: name,
        value: relValue,
        error: error,
        disabled: propsDisabled || disabled,
        touched: fieldTouched,
        handleChange: form.handleChange && form.handleChange.bind(this, name),
        handleBlur: form.handleBlur && form.handleBlur.bind(this, name)
      });

      var fieldCols = cols || form.cols || {};
      var labelSpan = get(fieldCols, 'label.span', 2);
      var labelOffset = get(fieldCols, 'label.offset', 0);
      var contentSpan = get(fieldCols, 'field.span', 4);
      var contentOffset = get(fieldCols, 'field.offset', 0);
      var isHorizontal = layout === 'horizontal';
      var labelCls = classNames('control-label', (_classNames = {
        'roo-input-required': required
      }, _defineProperty(_classNames, "col-sm-".concat(labelSpan), isHorizontal && withLabel), _defineProperty(_classNames, "offset-sm-".concat(labelOffset), isHorizontal && withLabel), _classNames));
      var contentCls = classNames('form-group-content', (_classNames2 = {}, _defineProperty(_classNames2, "col-sm-".concat(contentSpan), isHorizontal && withLabel), _defineProperty(_classNames2, "offset-sm-".concat(contentOffset), isHorizontal && withLabel), _defineProperty(_classNames2, 'has-error', status === 'error' || error && hasFeedback), _defineProperty(_classNames2, 'has-success-hook', status === 'success'), _classNames2));
      var fieldCls = classNames('form-group', {
        row: layout === 'horizontal' && withLabel,
        'roo-form-vertical': layout === 'vertical' && withLabel,
        'roo-form-inline': layout === 'inline' && withLabel
      });
      return /*#__PURE__*/React.createElement("div", {
        className: fieldCls
      }, (isHorizontal || label) && withLabel ? /*#__PURE__*/React.createElement("label", {
        className: labelCls,
        htmlFor: name
      }, label) : null, /*#__PURE__*/React.createElement("div", {
        className: contentCls
      }, this.renderContent(field, funcField), /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error,
        visible: hasFeedback
      })));
    }
  }]);

  return Field;
}(React.Component);

Field.propTypes = {
  type: PropTypes.string,
  hasFeedback: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  rule: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  inputRef: PropTypes.func,
  cols: PropTypes.object,
  status: PropTypes.oneOf(['', 'success', 'error']),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  layout: PropTypes.string,
  as: PropTypes.node,
  withLabel: PropTypes.bool
};
Field.defaultProps = {
  type: 'text',
  label: '',
  rule: null,
  inputRef: undefined,
  cols: null,
  status: '',
  disabled: false,
  required: false,
  hasFeedback: true,
  layout: undefined,
  as: null,
  withLabel: true
};
export { Field };
export default connect(Field);